import { Button } from "@/components/ui/baseUi/button"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import { useTemplateImportSelectedTemplate } from "@/modules/template/stores/useTemplateImportStore"
import { LoaderCircleIcon } from "lucide-react"

type TemplateButtonsProps = {
  onValidate: (templateId: string) => void
  onCancel?: () => void
  isLoading?: boolean
  className?: string
} & React.ComponentProps<"div">

export function TemplateButtons({ onValidate, onCancel, isLoading, className, ...props }: TemplateButtonsProps) {
  const selectedTemplate = useTemplateImportSelectedTemplate()
  const { hideSidebar } = useSidebar()

  return (
    <div className={cn("flex flex-row gap-2", className)} {...props}>
      <Button
        variant="outline"
        size="lg"
        className="flex-1"
        onClick={() => {
          if (onCancel) {
            onCancel()
          } else {
            hideSidebar()
          }
        }}
      >
        {word("global.cancel")}
      </Button>
      <Button
        variant="primary"
        size="lg"
        className="flex-1"
        disabled={!selectedTemplate || isLoading}
        onClick={() => {
          if (!selectedTemplate) return
          onValidate(selectedTemplate.id)
        }}
      >
        {isLoading ? <LoaderCircleIcon className="animate-spin" /> : word("global.import")}
      </Button>
    </div>
  )
}
